import type { Auth0IdTokenPayload } from "../types/auth0";

const nameTemplate = "{{name}}";
const roleTemplate = "{{role}}";

export const getUserInfo = (
  user: Auth0IdTokenPayload,
  salutation: string,
  roleDescription: string
): { salutation: string; roleDescription: string } => ({
  salutation: salutation.replace(
    nameTemplate,
    `${user["https://intouch/first_name"]}`
  ),
  roleDescription: roleDescription.replace(
    roleTemplate,
    user["https://intouch/intouch_role"]
  )
});

export const constructUrlWithPrevPage = (uri: string) => {
  const prevPage = `${window.location.origin}${window.location.pathname}`;
  return `${uri}?prev_page=${encodeURIComponent(prevPage)}`;
};
